module.exports = __webpack_public_path__ + "35d8d6066593d7ddeebf3ca10df0bfb0.svg";